import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DialogsContext from 'app/contexts/DialogsContext';

export const FileConfirmDeleteDialog = ({ onConfirm }) => {
  const { closeDialog } = useContext(DialogsContext);

  return (
    <>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        Are you sure you want to delete the selected file(s)?
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            closeDialog();
          }}
          color="error"
          autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </>
  );
};

FileConfirmDeleteDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};
